import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private oAuthService = inject(OAuthService);

  constructor(private router: Router, private baseService: BaseService, private sessionService: SessionWrapperService) { }

  intercept(request: HttpRequest<string>, next: HttpHandler): Observable<HttpEvent<string>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          // auto logout if 401 response returned from api
          //this.sessionService.clearSession();
          // setTimeout(() => {
            this.oAuthService.revokeTokenAndLogout();
            // this.oAuthService.logOut();
            this.sessionService.clearSession();
          // }, 2000)

          this.router.navigate(['/default']);
        }

        let validationErrors = err?.error?.error?.validationErrors;
        if (validationErrors && validationErrors.length > 0) {
          validationErrors.forEach(element => {
            this.baseService.showErrorMessage(element.message);
          });
        }
        let errorMessage = err?.error?.error?.message;
        this.baseService.showErrorMessage(errorMessage);

        // const error = err.error.message || err.statusText;
        const newError = new Error(err.error.message || err.statusText);
        return throwError(() => newError);
      })
    );
  }
}
